module.exports = __webpack_public_path__ + "img/客服.1f1bacee.png";